import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal, Button, Select, Input } from "antd";
import { NotificationManager } from "react-notifications";
import PurchaseOrderService from "../../services/purchaseOrder.service";
import StoneSummary from "./StoneSummary";

// Task 2188 (F5) -- matches Diamond-PO-Prototype-v3.html's openDiscrepancy()/doDiscrepancy()
// (lines 1173-1187) exactly: same reason list, same hint text, renamed from "Dispute" throughout
// (the plan's own change note calls this out explicitly).

const { Option } = Select;

const REASONS = [
  { code: "WEIGHT_GRADE", label: "Weight or grade does not match the report" },
  { code: "INSCRIPTION", label: "Inscription does not match the report" },
  { code: "DAMAGE", label: "Stone damaged (chip, crack)" },
  { code: "WRONG_STONE", label: "Wrong stone received" },
  { code: "MISSING", label: "Missing from parcel" },
  { code: "OTHER", label: "Other" },
];

export const DiscrepancyModal = ({ lineId, snap, supplierName, onClose, onDone }) => {
  const { t } = useTranslation();
  const loginDetials = useSelector((state) => state.loginReducer);
  const dealerId = loginDetials?.loginDetials?.responseData?.dealerId;

  const [reason, setReason] = useState(REASONS[0].code);
  const [note, setNote] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = () => {
    setSubmitting(true);
    PurchaseOrderService.ReportDiamondDiscrepancy(lineId, { DealerID: String(dealerId), Reason: reason, Note: note.trim() })
      .then((response) => {
        setSubmitting(false);
        if (response.data.status === true) {
          NotificationManager.success(t("Discrepancy reported — the supplier has been notified"));
          onDone && onDone();
          onClose();
        } else {
          NotificationManager.error(t(response.data.message || "Could not report this discrepancy"));
        }
      })
      .catch(() => {
        setSubmitting(false);
        NotificationManager.error(t("Could not report this discrepancy"));
      });
  };

  return (
    <Modal
      visible
      onCancel={onClose}
      title={t("Report a discrepancy")}
      footer={[
        <Button key="cancel" onClick={onClose}>{t("Cancel")}</Button>,
        <Button key="go" type="primary" loading={submitting} onClick={handleSubmit}>
          {t("Send to supplier")}
        </Button>,
      ]}
    >
      {snap && (
        <div style={{ marginBottom: 12 }}>
          <StoneSummary snap={snap} />
        </div>
      )}
      <div style={{ marginBottom: 10 }}>
        <label style={{ fontSize: 12, display: "block", marginBottom: 4 }}>{t("What doesn't match?")}</label>
        <Select style={{ width: "100%" }} value={reason} onChange={setReason}>
          {REASONS.map((r) => (
            <Option key={r.code} value={r.code}>{t(r.label)}</Option>
          ))}
        </Select>
      </div>
      <div>
        <label style={{ fontSize: 12, display: "block", marginBottom: 4 }}>{t("Details for the supplier")}</label>
        <Input.TextArea rows={3} value={note} onChange={(e) => setNote(e.target.value)} placeholder={t("e.g. Measured 1.98 ct on our scale")} />
      </div>
      <div style={{ fontSize: 12, color: "#79838f", marginTop: 8 }}>
        {t("This pauses the line — it cannot be bought or returned until {{supplier}} responds.", { supplier: supplierName })}
      </div>
    </Modal>
  );
};

export default DiscrepancyModal;
